import React from 'react';
import { useNavigate } from 'react-router-dom';

import character from '../../assets/images/intake/step2/char.svg';
import img5 from '../../assets/images/swot/step1/char.svg';

export const Greetings: React.FC = () => {
  const navigate = useNavigate();
  const handleNextButton = () => {
    navigate('/swot/step2');
  };
  return (
    <>
      <div className="character absolute bottom-0 left-[-138px] z-0">
        <img className="" src={character} alt="" />
      </div>
      <div className="text-center px-16">
        <img className="mx-auto mt-5" src={img5} alt="" />
        <p className="mt-8 text-xl">
          <div className="uppercase font-bold text-purple-700">
            <span>Hello There!</span>
          </div>
          <br />
          Congratulations on talking the first step towards your career goals with Vero Learning! We
          are thrilled to have you on board and excited to help you reach your full potential. Our
          Platform is designed to help you identify your unique skill set and match the best
          vocational opportunities from top companies.
        </p>
      </div>
      <div className="text-center mt-12">
        <button onClick={handleNextButton} className="btn-primary">
          Next
        </button>
      </div>
    </>
  );
};
